import { render, staticRenderFns } from "./PlayerProfile.vue?vue&type=template&id=6f85eb88&scoped=true"
import script from "./PlayerProfile.js?vue&type=script&lang=js&external"
export * from "./PlayerProfile.js?vue&type=script&lang=js&external"
import style0 from "./PlayerProfile.vue?vue&type=style&index=0&id=6f85eb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85eb88",
  null
  
)

export default component.exports